export default "__VITE_ASSET__DXfGBIrq__"